import {combine, guard, merge} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {data$ as commonData$, loadProfileCommonDataFx} from '../../profile/common';

import {
    data$,
    error$,
    fetchTracingDetailFx,
    fetchTracingGraphFx,
    Gate,
    graph$,
    period$,
    periodChanged,
} from './index';

data$.on(fetchTracingDetailFx.done, (state, {result}) => result).reset(Gate.close);
graph$.on(fetchTracingGraphFx.done, (state, {result}) => result).reset(Gate.close);
period$.on(periodChanged, (_, value) => value);

error$
    .on(fetchTracingDetailFx.fail, (_, {error}: {error: Error}) => error as RestError)
    .on(fetchTracingGraphFx.fail, (_, {error}: {error: Error}) => error as RestError)
    .reset(
        fetchTracingDetailFx,
        fetchTracingDetailFx.done,
        fetchTracingGraphFx,
        fetchTracingGraphFx.done,
        Gate.open,
        Gate.close,
    );

guard({
    clock: merge([periodChanged, loadProfileCommonDataFx.done]),
    source: combine({
        id: Gate.state.map((v) => v.id),
        gtin: Gate.state.map((v) => v.gtin),
        period: period$,
    }),
    filter: () => Gate.status.getState() && !!commonData$.getState(),
    target: fetchTracingDetailFx,
});

guard({
    clock: merge([fetchTracingDetailFx.doneData]),
    source: combine({
        id: data$.map((v) => v?.root?.id),
        gtin: Gate.state.map((v) => v.gtin),
        period: period$,
        skip: 0,
        limit: 5,
        producedQuantity: data$.map((v) => v?.producedQuantity),
        startQuantity: data$.map((v) => v?.startQuantity),
    }),
    filter: () => Gate.status.getState() && !!commonData$.getState(),
    target: fetchTracingGraphFx,
});

fetchTracingDetailFx.fail.watch(({error}) => showRestError(error as RestError));
fetchTracingGraphFx.fail.watch(({error}) => showRestError(error as RestError));
